import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberFormatter',
})
export class NumberFormatterPipe implements PipeTransform {
  transform(num: number): number {
    if (!num) return 0;
    return parseFloat((num / 10e6).toFixed(2));
  }
}
